/**
 *  Created by piotr@revisual.io on 18/08/2025
 */
import classNames from "classnames";
import { useMemo } from "react";

/**
 *
 * @param {number} usage
 * @param {number} limit
 * @returns {JSX.Element|null}
 * @constructor
 */
export const ComparisonBar = ({ usage, limit }) => {
  const _limit = Number(limit);

  const style = useMemo(
    () => ({
      width: `${(usage / _limit) * 100}%`,
    }),
    [usage, _limit]
  );

  if (_limit === -1) {
    return <div />;
  }

  return (
    <div
      className={classNames("comparison-bar", {
        "bg-danger": usage > _limit,
      })}
    >
      <div
        className={classNames("progress-bar", {
          "bg-danger": usage > _limit,
          "bg-primary": usage < _limit,
        })}
        style={style}
        role="progressbar"
        aria-valuenow={usage}
        aria-valuemin="0"
        aria-valuemax={_limit}
      ></div>
    </div>
  );
};

export default ComparisonBar;
